var map = {
	"./add.svg": "58n+",
	"./app-update.svg": "ZNEa",
	"./article_icon.svg": "ySNV",
	"./brand.svg": "hP9D",
	"./chart.svg": "RjYk",
	"./comment.svg": "SdtW",
	"./convert.svg": "+qJY",
	"./customerService.svg": "oduT",
	"./depot.svg": "4ngA",
	"./depotGoods.svg": "ql4r",
	"./douyinVideoQueue.svg": "jaBB",
	"./example.svg": "OOLB",
	"./exchangeRate.svg": "6oEa",
	"./exit-fullscreen.svg": "G+/G",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./home.svg": "U9Ws",
	"./integral.svg": "xFu/",
	"./jiesuan.svg": "MSVZ",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./live-setting.svg": "SFZU",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./member-chart.svg": "C9Cq",
	"./member-level.svg": "wyTZ",
	"./member.svg": "/LrJ",
	"./nested.svg": "798r",
	"./order-chart.svg": "DUSo",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./params.svg": "q9Pt",
	"./password.svg": "QjmH",
	"./peoples.svg": "TgHK",
	"./permission.svg": "j4kZ",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./products.svg": "NUSN",
	"./psfs.svg": "Ybuh",
	"./rate.svg": "h/JX",
	"./role.svg": "cqqK",
	"./shop-gl.svg": "7B7n",
	"./shop.svg": "hert",
	"./shopping.svg": "jRi0",
	"./shops.svg": "eOC4",
	"./size.svg": "Cr4N",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./staff.svg": "yyF4",
	"./sys-icon.svg": "AMuo",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./tuijian.svg": "g1SJ",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./video-comment.svg": "SjMe",
	"./video-live-member-auth.svg": "TA/s",
	"./video-live-plan.svg": "maXH",
	"./video-tag.svg": "V+Ew",
	"./video.svg": "3JNx",
	"./vms.svg": "Xacy",
	"./withdraw.svg": "/mAo",
	"./wlgs.svg": "hIhz",
	"./wuliu.svg": "NZEG",
	"./zt-prd.svg": "Z6Po"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 81